











import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import TriangleDownIcon from '@/assets/icons/icn-arrow-down.svg';

@Component({
  components: {
    TriangleDownIcon,
  },
})
export default class ShowDetailsButton extends Vue {
  @Prop() public isUpwards: boolean;

  @Emit('on-show-details-click')
  public onRowClick() {
  } // tslint:disable-line
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/ShowDetailsButton/ShowDetailsButton.vue